import axios from "../config/axiosInstance";
import endpoints from "./endpoints";

export const getDoctorSale = async (details) => {
  const response = await axios.put(endpoints.getDoctorSale, details);
  return response;
};

export const getDistributorSale = async (details) => {
  const response = await axios.put(endpoints.getDistributorSale, details);
  return response;
};

export const getDistributorWithCount = async (details) => {
  const response = await axios.put(endpoints.getDistributorWithCount, details);
  return response;
};

export const getProductSale = async (details) => {
  const response = await axios.put(endpoints.getProductSale, details);
  return response;
};
